import axios from 'axios'
import qs from 'qs'
import { indexOf } from 'ramda'
import i18n from 'i18next'

import { IASMError, ErrorCode, ErrorCodeHandle } from 'utils/staticData'

export const BASE_URL = '/api'

const errMsg = (code, isErrorCodeHandle) => {
    if (indexOf(code, ErrorCode) !== -1) {
        return isErrorCodeHandle
            ? { errMsg: i18n.t(`ErrorCode.${code}`), errorCode: code }
            : i18n.t(`ErrorCode.${code}`)
    } else {
        return isErrorCodeHandle ? { errMsg: i18n.t(`ErrorCode.99999`), errorCode: code } : i18n.t(`ErrorCode.99999`)
    }
}

const ktspUrl = process.env.NODE_ENV === 'development' ? BASE_URL : process.env.REACT_APP_BASE_URL + BASE_URL

export const http = axios.create({
    baseURL: ktspUrl,
    timeout: 30000,
    headers: {
        'Content-Type': 'application/json',
    },
    paramsSerializer: function (params) {
        return qs.stringify(params, { arrayFormat: 'repeat', allowDots: true }) /// 传递数组 paramsSerializer序列化 ids:[1,2,3] -> ids=1&ids=2&id=3
    },
})

http.interceptors.request.use(async (config) => {
    //   const token = await localStorage.getItem("Authorization");
    //   if (token) {
    //     config.headers = {
    //       ...config.headers,
    //       token,
    //     };
    //   }
    if (config.url?.includes('/loginReg/addUserFail')) {
        config.headers['tracingId'] = 'web-reg-' + crypto.randomUUID()
    }
    return config
})

http.interceptors.response.use(({ data, status, config }) => {
    if (data instanceof Blob) {
        return data
    }
    if (status === 200 && data.errorCode === '00000') {
        return data.result
    } else if (status === 200 && indexOf(data.errorCode, IASMError) !== -1) {
        return data
    } else if (ErrorCodeHandle.includes(config.url)) {
        throw errMsg(data.errorCode, true)
    } else {
        throw errMsg(data.errorCode)
    }
})
